export default __webpack_public_path__ + "images/45a39910668c1148a8e893cd9972867e.png";